import * as React from 'react'

import { Footer } from './Footer'
import { Content } from './Content'
import { useResultsActions } from './hooks'
import { WizardScreen } from '../WizardScreen'

export function Results() {
  const { bodyRef, ...rest } = useResultsActions()

  return (
    <WizardScreen
      ref={bodyRef}
      screen="results"
      footer={<Footer {...rest} />}
      padding={0}
    >
      <Content {...rest} />
    </WizardScreen>
  )
}
